import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

function rand(seed, min, max) {
  const x = Math.sin(seed * 9973) * 43758.5453;
  const frac = x - Math.floor(x);
  return min + frac * (max - min);
}

export default function HeroMotion({ accentA = "#22d3ee", accentB = "#34d399" }) {
  const reduce = useReducedMotion();

  const dots = useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => ({
        left: `${rand(i, 0, 100)}%`,
        top: `${rand(i + 1, 0, 100)}%`,
        size: rand(i + 2, 6, 12),
        dx: rand(i + 3, -20, 20),
        dy: rand(i + 4, -20, 20),
        dur: rand(i + 5, 8, 16),
        delay: rand(i + 6, 0, 4),
      })),
    []
  );

  if (reduce) return null; // honor prefers-reduced-motion

  return (
    <div className="absolute inset-0 z-0 pointer-events-none">
      {/* Slow gradient blobs */}
      <motion.div
        className="absolute -top-24 -left-24 h-80 w-80 rounded-full blur-3xl opacity-20"
        style={{ background: `radial-gradient(closest-side, ${accentA}, transparent)` }}
        animate={{ x: [0, 40, 0], y: [0, -30, 0] }}
        transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute -bottom-24 -right-24 h-96 w-96 rounded-full blur-3xl opacity-20"
        style={{ background: `radial-gradient(closest-side, ${accentB}, transparent)` }}
        animate={{ x: [0, -40, 0], y: [0, 30, 0] }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
      />
      {/* Floating dots */}
      {dots.map((d, idx) => (
        <motion.span
          key={idx}
          className="absolute rounded-full"
          style={{
            left: d.left,
            top: d.top,
            width: d.size,
            height: d.size,
            background: accentA,
            opacity: 0.6,
          }}
          animate={{ x: [0, d.dx, 0], y: [0, d.dy, 0], opacity: [0.35, 0.85, 0.35] }}
          transition={{ duration: d.dur, delay: d.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
      {/* Faint grid for depth */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.06)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.06)_1px,transparent_1px)] [background-size:24px_24px]" />
    </div>
  );
}
